import { gql } from '@apollo/client'

export const GET_STAGE = gql`
  query {
    approvalStages {
      id
      name
      active
      order_number
      is_payment_stage
      workflow {
        id
        name
      }
      approval_role {
        id
        name
      }
    }
  }
`

export const CREATE_STAGE = gql`
  mutation CreateApprovalStage($input: ApprovalStageInput!) {
    createApprovalStage(input: $input) {
      order_number
      is_payment_stage
      workflow {
        id
      }
      approver_role {
        id
      }
    }
  }
`

export const UPDATE_STAGE = gql`
  mutation UpdateApprovalStage($id: ID!, $input: ApprovalStageInput!) {
    updateApprovalStage(id: $id, input: $input) {
      id
      order_number
      is_payment_stage
      workflow {
        id
      }
      approver_role {
        id
      }
    }
  }
`

export const DELETE_STAGE = gql`
  mutation DeleteApprovalStage($id: ID!) {
    deleteApprovalStage(id: $id)
  }
`
